import { t } from 'i18next';
import * as yup from 'yup';

import { getEmptyErrorMessage } from 'core/yup';

export const changeOwnerSchema = () =>
  yup.object().shape({
    user: yup
      .object()
      .nullable()
      .required(getEmptyErrorMessage(t('labelUser'))),
  });

export const changeContactGroupingSchema = () =>
  yup.object().shape({
    contactGrouping: yup
      .object()
      .nullable()
      .required(getEmptyErrorMessage(t('labelContactGrouping'))),
  });
